import { render, staticRenderFns } from "./ChatPanelItem.vue?vue&type=template&id=bf07d20a&scoped=true&"
import script from "./ChatPanelItem.vue?vue&type=script&lang=js&"
export * from "./ChatPanelItem.vue?vue&type=script&lang=js&"
import style0 from "./ChatPanelItem.vue?vue&type=style&index=0&id=bf07d20a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf07d20a",
  null
  
)

export default component.exports